export default "__VITE_ASSET__B6$FM7_U__"